/* @flow */
import { OrderedMap, fromJS } from 'immutable';
import { getterFromKeyPath, alphabetize } from 'trustar/utils';
import { createSelector } from 'reselect';

export const getEntityTypes = getterFromKeyPath(['miscellaneous', 'entityTypes']);
export const getEntityTypesLoading = getterFromKeyPath(['miscellaneous', 'entityTypesLoading']);
export const getSelectedEntityTypes = getterFromKeyPath(['miscellaneous', 'selectedEntityTypes']);
export const credentialsTypes = getterFromKeyPath(['miscellaneous', 'credentialsTypes']);
export const accessTypes = getterFromKeyPath(['miscellaneous', 'accessTypes']);
export const patterns = getterFromKeyPath(['miscellaneous', 'patterns']);
export const labels = getterFromKeyPath(['miscellaneous', 'labels']);
export const subscriptionMethods = getterFromKeyPath(['miscellaneous', 'subscriptionMethods']);

/**
 * Get a Set of the currently selected entity type Ids. See the
 * selectedEntityTypes store for more details.
 */
export const getCurrentEntityTypes = createSelector(
  [getEntityTypes, getSelectedEntityTypes],
  (entityTypes, selected) => {
    return entityTypes
      .keySeq()
      .toSet()
      .intersect(selected);
  }
);

export const getFullEntityTypes = createSelector(
  [getEntityTypes, getCurrentEntityTypes],
  (entityTypes, selected) => {
    return entityTypes.filter(x => selected.has(x.get('guid')));
  }
);

export const getEntityTypesList = createSelector(
  [getEntityTypes],
  x => x.toList().sort(alphabetize),
);

export const getDefaultEntityTypes = createSelector(
  [getEntityTypesList],
  entityTypes => OrderedMap(
    entityTypes
      .filter(x => x.get('default'))
      .map(x => [x.get('guid'), x])
  ),
);




// WEBPACK FOOTER //
// ./src/app/modules/miscellaneous/getters.js